<script>
    import { mapState } from 'vuex';
    export default {
        name: 'currentUser',
        computed: {
            ...mapState({
                $user: s => s.auth.user
            })
        },
        methods: {
            // Usage: this.userHasPermissions(['ROLE_NAME'])
            $p(keys, checkType){
                let vm = this
                 // If you are not logged in, you have no permissions.
                if(!vm.$user) return false

                let or = (checkType === 'or')
                let valid = (or) ? false : true

                _.map(keys, key => {
                    let roleToCheck = vm.$user.ROLES[key]
                    if( or ){
                        valid = (valid === true || roleToCheck) ? true : false
                    }
                    else{
                        valid = (valid === true && roleToCheck) ? true : false
                    }
                })
                return valid
            },
            currentUser(){
                return this.$user
            }
        }
    }
</script>